import React from 'react'
import BaseLogo from './base-logo.component'

export const Flex500Logo = ({ fontSize }) => (
	<BaseLogo fontSize={fontSize}>
		<div className="name">flex</div>
		<div className="points yellow">500</div>
	</BaseLogo>
)
